<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <h2 class="text-center">Corp Plus CMS</h2>
        </v-card-title>

        <!-- login form -->
        <v-card-text>
          <v-form v-model="formValid" :disabled="$store.getters.isLoading" @submit.prevent="">
            <form-input label="form.account" :fieldValue.sync="username" required :persistentPlaceholder="false" />

            <form-input
              label="form.password"
              :fieldValue.sync="password"
              type="password"
              required
              :persistentPlaceholder="false"
              showPwView
            />

            <v-btn
              depressed
              :loading="$store.getters.isLoading"
              :disabled="!formValid"
              block
              elevation="0"
              color="primary"
              class="mt-6"
              type="button"
              @click="formValid && submitLogin()"
            >{{ $t('login') }}</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { defaultPage, developerUsername } from '@/assets/cannotAccessList'

import FormInput from '@/components/form/FormInput.vue'

export default {
  name: 'Login',
  components: {
    FormInput,
  },
  setup() {
    return {
      icon: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
  data: () => ({
    formValid: false,
    isPasswordVisible: false,
    username: '',
    password: '',
  }),

  methods: {
    async submitLogin() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      if (!this.formValid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true)

      try {
        const data = await this.$Fetcher.Login(this.username, this.password)
        let userType = 'admin';
        if (developerUsername.includes(data.username)) {
          userType = 'developer';
        }
        await this.setUserData({
          id: data.id,
          user_type: userType,
          last_login: new Date().getTime(),
          username: data.username,
        })

        if (this.$validate.DataValid(defaultPage[userType])) {
          this.$router.replace(defaultPage[userType])
        }
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('toggleSnack', {
          type: 'error',
          message: 'message.wrongAccountOrPassword',
        })
        this.$store.dispatch('setLoading', false)
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
